const t = {
  SET_BILLING_ADDRESS: 'SHIPMENT_ADDRESS/SET_BILLING_ADDRESS',
  SET_SHIPPING_ADDRESS: 'SHIPMENT_ADDRESS/SET_SHIPPING_ADDRESS',
  SET_SHIPPING_ADDRESSES: 'SHIPMENT_ADDRESS/SET_SHIPPING_ADDRESSES',
  ADD_SHIPPING_ADDRESS: 'SHIPMENT_ADDRESS/ADD_SHIPPING_ADDRESS',
  UPDATE_SHIPPING_ADDRESS: 'SHIPMENT_ADDRESS/UPDATE_SHIPPING_ADDRESS',
  REMOVE_SHIPPING_ADDRESS: 'SHIPMENT_ADDRESS/REMOVE_SHIPPING_ADDRESS',
  RESET: 'SHIPMENT_ADDRESS/RESET',
};

export default t;
